import React from "react";
import { isEqual } from "lodash";
import classNames from "classnames";

import Checkbox from "components/Input/Checkbox";
import Tooltip from "components/Tooltip";
import NameInput from "components/Input/NameInput";
import { useEnclosureSelection } from "../../EnclosureSelectionContext";

import sharedClasses from "../style.module.scss";

const ComponentHeading = React.memo(
    ({
        nameField,
        type,
        componentId,
        // isDrawingComponent, // TODO: Dmitrii check if used in old or new drawing component
        icon: Icon,
        className,
        isStaticLabel = false,
        label = "No Label",
        draggableId,
    }) => {
        const { isSelected, isDirectlySelected, toggleSelected, canSelect } = useEnclosureSelection();
        const showCheckbox = Boolean(draggableId);
        const checked = showCheckbox && isSelected(draggableId);
        const directlySelected = showCheckbox && isDirectlySelected(draggableId);
        // Inherited from a selected parent: show checkmark but don't allow toggling here
        const inheritedSelected = checked && !directlySelected;
        const blockedByCompatibility = showCheckbox && !checked && !canSelect(draggableId);
        const canToggle = directlySelected || (!checked && canSelect(draggableId));

        return (
            <>
                <span className={classNames(sharedClasses.heading, { [className]: className })}>
                    {showCheckbox && (
                        <span
                            className={classNames(sharedClasses.selectionCheckbox, {
                                [sharedClasses.selectionCheckboxDisabled]: blockedByCompatibility,
                                [sharedClasses.selectionCheckboxInherited]: inheritedSelected,
                            })}
                            data-selection-checkbox="true"
                            role="presentation"
                            onClick={(event) => {
                                // Own the toggle here. preventDefault stops the label from also
                                // flipping the native input; stopPropagation keeps the accordion closed.
                                event.preventDefault();
                                event.stopPropagation();
                                if (canToggle) {
                                    toggleSelected(draggableId);
                                }
                            }}
                            onMouseDown={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                            }}
                            onPointerDown={(event) => event.stopPropagation()}
                        >
                            <Checkbox
                                name={`select-${draggableId}`}
                                hideLabel
                                compact
                                noPadding
                                disabled={blockedByCompatibility}
                                input={{
                                    value: checked,
                                    onChange: () => {
                                        if (canToggle) {
                                            toggleSelected(draggableId);
                                        }
                                    },
                                }}
                            />
                        </span>
                    )}
                    <img src={Icon} alt="Wall icon" />

                    {isStaticLabel ? (
                        <p>{label}</p>
                    ) : (
                        <NameInput
                            nameField={nameField}
                            type={type}
                            placeholder={`Name your ${type}`}
                            onClick={(event) => event.stopPropagation()}
                            tabIndex={-1}
                        />
                    )}
                    {/* {isDrawingComponent && (
                        <span
                            className={sharedClasses.drawingIcon}
                            data-tip="<span style='display:block;width:100%;text-align:center;'>This component was created using the <strong>Drawing Capture</strong> tool.</span>"
                            data-html
                            data-for={`headingTip_${componentId}`}
                        >
                            <DrawingIcon />
                        </span>
                    )} */}
                </span>
                <Tooltip id={`headingTip_${componentId}`} />
            </>
        );
    },
    isEqual
);

export default ComponentHeading;
